export default function Loading(params) {
    return (
        <>
        <div role="status" className="container px-5 mx-auto xl:px-[5%] mt-6 animate-pulse">
            <div className="w-full h-[400px] bg-gray-300 rounded-2xl"></div>
            <div className="w-1/2 bg-gray-300 rounded-xl h-5 mt-10"></div>
            <div className="w-1/3 bg-gray-300 rounded-xl h-5 mt-4"></div>
            <div className="grid mt-5 gap-7 grid-cols-2 md:mb-8 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
            </div>
            <div className="w-1/2 bg-gray-300 rounded-xl h-5 mt-10"></div>
            <div className="w-1/3 bg-gray-300 rounded-xl h-5 mt-4"></div>
            <div className="grid mt-5 gap-7 grid-cols-2 md:mb-8 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
            </div>
            <div className="grid mt-5 gap-7 grid-cols-2 md:mb-8 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[300px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
            </div>

            <div className="w-1/2 bg-gray-300 rounded-xl h-5 mt-10"></div>
            <div className="w-1/3 bg-gray-300 rounded-xl h-5 mt-4"></div>
            <div className="grid mt-5 gap-7 grid-cols-2 md:mb-8 md:grid-cols-3 lg:grid-cols-4">
                <div className="bg-gray-300 w-full h-[400px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[400px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[400px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
                <div className="bg-gray-300 w-full h-[400px] p-5 rounded-xl">
                    <div className="bg-gray-200 rounded-xl w-full h-1/2"></div>
                    <div className="w-2/3 bg-gray-200 rounded-xl h-3 mt-10"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-4"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                    <div className="w-1/2 bg-gray-200 rounded-xl h-2 mt-2"></div>
                </div>
            </div>
        </div>
        </>
    )
};
